import { ErrorsExtension } from '@wix/package-picker-shared';
import React from 'react';
import { AppErrorsMapper } from './AppErrorsMapper';
export const EclipseErrorsExtension = function (_temp) {
  let {
    notificationButtonType
  } = _temp === void 0 ? {} : _temp;
  return ErrorsExtension({
    ErrorsMapper: _ref => {
      let {
        error
      } = _ref;
      return /*#__PURE__*/React.createElement(AppErrorsMapper, {
        error: error
      });
    },
    notificationButtonType
  });
};
//# sourceMappingURL=eclipse-errors.extension.js.map